
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-host",
      function () {
        return require("private-next-pages/become-a-host/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-host"])
      });
    }
  